import { USER_ROLES } from "@/constants";

export default {
  isAuthenticated(state) {
    const user = state.user;
    return !!user && !user.expired;
  },
  token(state) {
    return state.user?.accessToken;
  },
  identityUserId(state) {
    return state.user?.profile?.sub;
  },
  identityUserName(state) {
    return state.user?.profile?.name;
  },
  hasComplianceReviewRole(state) {
    return state.user?.profile?.role?.includes(USER_ROLES.COMPLIANCE_REVIEW);
  }
};
